import {Drawer} from '@esgi/main/features/teacher/home';
import {styled} from '@esgi/ui/theme';

export const DrawerBody = styled(Drawer.Body, {
	gridTemplateRows: 'auto 1fr',
});
